module.exports = __webpack_public_path__ + "static/media/tela-aplicativo.d64c1edc.png";